(function(){
  'use strict';
  if(window.MirroredCartRefresh)return;
  const site=document.currentScript?.dataset.mirrorSite;
  if(!site)return;
  const nativeFetch=window.fetch.bind(window),root=window.Shopify?.routes?.root||'/';
  const checked=new Map();let queue=Promise.resolve(),inFlight;
  const storageKey=`mirror-refresh:plain:${site}`,maxAge=300000;
  try{for(const [key,value] of JSON.parse(sessionStorage.getItem(storageKey)||'[]'))if(value.until>Date.now())checked.set(key,value);}catch{}
  const identity=line=>JSON.stringify([String(line.variant_id),line.properties||{}]);
  function remember(line,quote){
    // No shop timezone is exposed here. UTC+14 is the earliest possible expiry.
    const expiry=Date.parse(`${quote.expiresAt?.slice(0,10)}T23:59:59+14:00`);
    const until=Math.min(Date.now()+maxAge,expiry-60000);
    if(!Number.isFinite(until)||until<=Date.now())return;
    checked.set(identity(line),{until});
    for(const [key,value] of checked)if(value.until<=Date.now())checked.delete(key);
    try{sessionStorage.setItem(storageKey,JSON.stringify([...checked].slice(-50)));}catch{}
  }
  const messages={es:'No se pudieron actualizar los artículos en espejo. Vuelve a intentarlo. Tus artículos siguen en el carrito.',de:'Die Preise Ihrer gespiegelten Artikel konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut. Ihre Artikel bleiben im Warenkorb.',fr:'Impossible de mettre à jour les prix des articles en miroir. Réessayez. Vos articles restent dans le panier.'};
  const message=messages[site]||'We could not refresh your mirrored items. Please try again. Your items remain in your cart.';
  function report(){
    let alert=document.querySelector('[data-mirror-refresh-error]');
    if(!alert){alert=document.createElement('p');alert.dataset.mirrorRefreshError='';alert.setAttribute('role','alert');document.querySelector('main')?.prepend(alert);}
    alert.textContent=message;
  }
  async function json(url,options){
    const response=await nativeFetch(url,{...options,signal:AbortSignal.timeout(url.includes('/checkout-image')?90000:30000)});
    if(!response.ok)throw new Error('Mirror cart refresh failed');
    return response.json();
  }
  async function refresh(){
    let cart=await json(`${root}cart.js`),changed=false;
    const candidates=cart.items.filter(line=>line.properties?._mirror_quote);
    async function renew(original){
      const token=original.properties._mirror_quote;
      if((checked.get(identity(original))?.until||0)>Date.now())return null;
      let fresh;
      if(site==='es'){
        const source=original.properties._mirror_source_variant||String(original.properties['Original Product']||'').match(/\/variants\/(\d+)/)?.[1];
        const image=original.properties._mirror_checkout_image||original.properties['Flipped Image'];
        if(!/^\d+$/.test(String(source||''))||!String(image||'').startsWith('https://cdn.shopify.com/s/files/'))throw new Error('Missing original item information');
        const imageResponse=await nativeFetch(image,{signal:AbortSignal.timeout(30000)});
        if(!imageResponse.ok)throw new Error('Image unavailable');
        const blob=await imageResponse.blob();
        if(blob.size>=20*1024*1024)throw new Error('Image too large');
        const hash=[...new Uint8Array(await crypto.subtle.digest('SHA-256',await blob.arrayBuffer()))].map(b=>b.toString(16).padStart(2,'0')).join('');
        const endpoint='https://shopify-mailer-zyf.onrender.com/api/storefront/mirrored-backdrop/';
        const quote=await json(endpoint+'quote?site=es',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({sourceVariantId:`gid://shopify/ProductVariant/${source}`,crop:{rect:{x:0,y:0,width:1,height:1}},files:[{hash}]})});
        if(!quote.properties?._mirror_quote||String(quote.variantId)!==String(original.variant_id))throw new Error('Invalid quote');
        const imageBase64=await new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(String(reader.result).split(',')[1]);reader.onerror=reject;reader.readAsDataURL(blob);});
        const registered=await json(endpoint+'checkout-image?site=es',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({quote:quote.properties._mirror_quote,imageBase64})});
        const properties={...quote.properties,...registered.properties};
        properties['Original Product']=properties._mirror_source_url;properties['Original SKU']=properties._mirror_source_sku;properties['Flipped Image']=properties._mirror_checkout_image;
        const signedPayload=JSON.parse(properties._mirror_quote.slice(0,properties._mirror_quote.lastIndexOf('|')));
        if(signedPayload.store!=='katebackdrop-es.myshopify.com'||!/^\d{4}-\d{2}-\d{2}T23:59:59$/.test(signedPayload.expiresAt||''))throw new Error('Invalid quote expiry');
        fresh={variantId:quote.variantId,properties,expiresAt:signedPayload.expiresAt};
      }else{
        fresh=await json(`https://shopify-mailer-zyf.onrender.com/api/storefront/mirrored-backdrop/renew?site=${encodeURIComponent(site)}`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({quote:token,variantId:original.variant_id,properties:original.properties})});
      }
      const keys=['Material','Original Product','Original SKU','Flipped Image','_mirror_quote'];
      if(String(fresh.variantId)!==String(original.variant_id)||keys.some(key=>!fresh.properties[key]))throw new Error('Invalid customization renewal');
      return {original,properties:fresh.properties,expiresAt:fresh.expiresAt};
    }
    // Prepare at most three independent rows at a time; cart writes remain serial.
    for(let offset=0;offset<candidates.length;offset+=3){
      const results=await Promise.allSettled(candidates.slice(offset,offset+3).map(renew));
      const failure=results.find(result=>result.status==='rejected');
      if(failure)throw failure.reason;
      for(const result of results){
      if(!result.value)continue;
      const {original,properties:freshProperties,expiresAt}=result.value;
      cart=await json(`${root}cart.js`);
      const current=cart.items.find(line=>line.key===original.key);
      if(!current)continue;
      if(identity(current)!==identity(original))throw new Error('Mirror item changed during refresh');
      const properties={...freshProperties,'Image Orientation':'Mirrored'};
      cart=await json(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:current.key,quantity:current.quantity,properties})});
      const updated=cart.items.find(line=>identity(line)===identity({...current,properties}));
      if(!updated)throw new Error('Mirror cart update was not confirmed');
      remember(updated,{expiresAt});changed=true;
      }
    }
    if(changed)document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart}}));
    const alert=document.querySelector('[data-mirror-refresh-error]');if(alert)alert.textContent='';
    return cart;
  }
  function serial(action){
    const run=()=>navigator.locks?.request?navigator.locks.request('mirrored-cart-refresh',action):action();
    const task=queue.then(run);queue=task.catch(()=>{});return task;
  }
  function ensure(){
    if(!inFlight){
      const task=serial(refresh).catch(error=>{report();throw error;}).finally(()=>{if(inFlight===task)inFlight=null;});
      inFlight=task;
    }
    return inFlight;
  }
  window.MirroredCartRefresh={ensure};
  window.fetch=function(input,options){
    const url=new URL(typeof input==='string'?input:input.url||input,location.href);
    if(url.origin!==location.origin||!/^\/.*cart\/(add|change|update)(\.js)?$/.test(url.pathname))return nativeFetch(input,options);
    // A checkout requested after this edit must inspect the resulting cart.
    inFlight=null;
    return serial(async()=>{
      try{await refresh();}catch(error){report();}
      // A signed stale row must not prevent unrelated cart edits or additions.
      // Native checkout still requires ensure() to complete successfully.
      return nativeFetch(input,options);
    });
  };
  // Native checkout posts must also wait for every stale row to be renewed.
  const replaying=new WeakSet();
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(replaying.has(form))return;
    const action=new URL(form.action||location.href,location.href);
    const checkout=event.submitter?.name==='checkout'||/\/checkout\/?$/.test(action.pathname);
    if(!checkout)return;
    event.preventDefault();event.stopImmediatePropagation();const submitter=event.submitter;
    ensure().then(()=>{replaying.add(form);try{form.requestSubmit(submitter?.form===form?submitter:undefined);}finally{replaying.delete(form);}}).catch(()=>{});
  },true);
  // Normal cart editing and other products' add-to-cart requests share the gate.
  const start=()=>ensure().catch(()=>{});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  addEventListener('pageshow',event=>{if(event.persisted)start();});
})();
